export default __webpack_public_path__ + "static/media/shohailZindani.6a65d4b6.png";